export default function toggleBodyScrollBar(off) {
    if(off){
        document.body.style = "overflow-y:hidden"
    } else {
        if(document.querySelectorAll(".Modal.opened").length <= 1)
            document.body.style = "overflow-y:auto"
    }
}